export default __webpack_public_path__ + "static/percentage-38848ad07f10586b53d81bebc243aa1c.svg";